import { MinusCircleIcon, PlusCircleIcon } from '@grupoboticario/flora-react-icons';
import { Icon } from 'ui/components/primitives';
import { cart } from 'core';
import QuantitySelector from './QuantitySelector.styles';
import useQuantitySelector from './QuantitySelector.hooks';
import type { QuantitySelectorProps } from './QuantitySelector.d';

const QuantitySelectorBase = ({
  disabled = false,
  isCombo = false,
  max = 9999,
  min = 0,
  onChange,
  productCode = '',
  size,
  value = 0,
  name,
}: QuantitySelectorProps) => {
  const { currentValue, handleChange, handleDecrement, handleIncrement } = useQuantitySelector({
    max,
    min,
    onChange,
    value,
  });

  const isMinimumDisabled = disabled || currentValue === min;
  const isMaximumDisabled = disabled || currentValue === max;

  const { toggleComboEditConfirmation } = cart.commands.useCartCommand();
  const toggleComboModal = () => {
    toggleComboEditConfirmation(parseInt(productCode.toString(), 10));
  };

  return (
    <QuantitySelector.Component data-size={size} data-testid="quantity-selector">
      <QuantitySelector.Button
        data-testid="button-minus"
        disabled={isMinimumDisabled}
        tabIndex={0}
        aria-label={`clique para reduzir uma quantidade de ${name}`}
        onClick={isCombo && value > 1 ? toggleComboModal : handleDecrement}
        stretch
      >
        <MinusCircleIcon size={24} />{' '}
      </QuantitySelector.Button>

      <QuantitySelector.InputQuantity
        data-testid="input"
        disabled={disabled}
        aria-label={'Digite a quantidade desejada'}
        id="inputQuantity"
        max={max}
        min={min}
        name="input-quantity"
        onChange={isCombo ? toggleComboModal : handleChange}
        type="number"
        value={Number(currentValue).toFixed()}
      />

      <QuantitySelector.Button
        data-testid="button-plus"
        disabled={isMaximumDisabled}
        tabIndex={0}
        aria-label={`clique para aumentar uma quantidade de ${name}`}
        onClick={isCombo ? toggleComboModal : handleIncrement}
        stretch
      >
        <PlusCircleIcon size={24} />
      </QuantitySelector.Button>
    </QuantitySelector.Component>
  );
};

export default QuantitySelectorBase;
